export default function additionalPhoneCountryCodesForCountry(countryCode) {
  switch (countryCode) {
    case 'GB':
      return ['GG', 'IM', 'JE']
    default:
      return []
  }
}
